// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as PlanRouteImport } from './routes/plan'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ExploreRouteImport } from './routes/explore'
import { Route as DiscoverRouteImport } from './routes/discover'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LegalTermsRouteImport } from './routes/legal.terms'
import { Route as LegalPrivacyRouteImport } from './routes/legal.privacy'
import { Route as AdminLoginRouteImport } from './routes/admin.login'
import { Route as AdminEventsRouteImport } from './routes/admin.events'
import { Route as AuthenticatedAccountRouteImport } from './routes/_authenticated/account'

const UnsubscribeRoute = UnsubscribeRouteImport.update({
            id: '/unsubscribe',path: '/unsubscribe',getParentRoute: () => rootRouteImport
          })
const PlanRoute = PlanRouteImport.update({
            id: '/plan',path: '/plan',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const ExploreRoute = ExploreRouteImport.update({
            id: '/explore',path: '/explore',getParentRoute: () => rootRouteImport
          })
const DiscoverRoute = DiscoverRouteImport.update({
            id: '/discover',path: '/discover',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRoute = AuthenticatedRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const LegalTermsRoute = LegalTermsRouteImport.update({
            id: '/legal/terms',path: '/legal/terms',getParentRoute: () => rootRouteImport
          })
const LegalPrivacyRoute = LegalPrivacyRouteImport.update({
            id: '/legal/privacy',path: '/legal/privacy',getParentRoute: () => rootRouteImport
          })
const AdminLoginRoute = AdminLoginRouteImport.update({
            id: '/admin/login',path: '/admin/login',getParentRoute: () => rootRouteImport
          })
const AdminEventsRoute = AdminEventsRouteImport.update({
            id: '/admin/events',path: '/admin/events',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAccountRoute = AuthenticatedAccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => AuthenticatedRoute
          })





const AuthenticatedRouteChildren = {
  AuthenticatedAccountRoute: AuthenticatedAccountRoute
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(AuthenticatedRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRoute: AuthenticatedRouteWithChildren,DiscoverRoute: DiscoverRoute,ExploreRoute: ExploreRoute,LoginRoute: LoginRoute,PlanRoute: PlanRoute,UnsubscribeRoute: UnsubscribeRoute,AdminEventsRoute: AdminEventsRoute,AdminLoginRoute: AdminLoginRoute,LegalPrivacyRoute: LegalPrivacyRoute,LegalTermsRoute: LegalTermsRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)